import { createReducer, createActions } from 'reduxsauce'
import { storage } from '@utils'

export const INITIAL_STATE = {}

const {Types, Creators} = createActions({
  loginUser: ['data'],
  updateUser: ['callback'],
  updateUserStore: ['data'],
  logoutUser: null,
  getUserProfile: ['data']
})

const loginUser = (state, { data }) => ({ ...state, ...data })
const updateUser = (state, { data }) => ({ ...state, ...data })
const getUserProfile = (state, { data }) => ({ ...state, ...data })

const logoutUser = () => {
  storage.clear('fb-onboarding-mozrest:token')
  storage.clear('fb-onboarding-mozrest:userData')
  storage.clear('fb-onboarding-mozrest:refreshtoken')
  storage.clear('persist:mozrest')
  storage.clear('fb-onboarding-mozrest:companyType')
  storage.clear('fb-onboarding-mozrest:totalVenues')
  storage.clear('fb-onboarding-mozrest:provider')
  return {}
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN_USER]: loginUser,
  [Types.LOGOUT_USER]: logoutUser,
  [Types.UPDATE_USER]: null,
  [Types.UPDATE_USER_STORE]: updateUser,
  [Types.GET_USER_PROFILE]: getUserProfile
})

export const UserTypes = Types
export default Creators
